import React from 'react';

const ErrorMessage = ({ errors, touched }) => {
	if (errors && touched) {
		return <div className='form-message invalid'>{errors}</div>;
	}
	return true;
};

export default ErrorMessage;
